import React from "react";
import {
  ButtonPrimary,
  ContentWithImage,
  Headline,
  SectionContent,
  Text,
} from "../../../../components";
import FiqueAtentoImg from "../../../../assets/images/consorcio/ilustracao-exclamacao-fique-atento.svg";
import * as S from "./FazerDenuncia.Style";

const FazerDenuncia = () => {
  return (
    <SectionContent>
      <ContentWithImage
        imgSrc={FiqueAtentoImg}
        imgAlt="Ilustração fique atento"
        imgColumnSize={4}
        hideMobile
      >
        <S.SectionInfo>
          <Headline nivel="2" styleAs="5">
            Você sabia?
          </Headline>
          <Text bodyStrong>
            Nós não comercializamos cotas contempladas de consórcios, assim como
            não garantimos a data de contemplação.
          </Text>
        </S.SectionInfo>
        <S.SectionInfo>
          <Headline nivel="2" styleAs="5">
            Identificou algum indício de fraude?
          </Headline>
          <Text bodyStrong>
            Faça uma denúncia. Elas são tratadas com sigilo e, mesmo que você se
            identifique, garantimos que sua identidade não será revelada.
          </Text>
          <S.DenunciaButton
            as={ButtonPrimary}
            target="_blank"
            href="https://www.contatoseguro.com.br/cnpholdingbrasil"
          >
            Fazer uma denúncia
          </S.DenunciaButton>
        </S.SectionInfo>
      </ContentWithImage>
    </SectionContent>
  );
};

export default FazerDenuncia;
